export default {
  title: 'Konto verwalten',
  buttons: {
    save: 'Speichern',
    delete: 'Löschen',
  },
};
